import React, { Component } from 'react'
import  {Modal, Dropdown} from 'react-bootstrap' 
  import styles from '../../Css/HomeBookDemoModal.module.css'
  import { InlineWidget } from "react-calendly";
  import { imageSrc } from '../SpyneHome/HomeImagesConfig'; 

export default class HomeBookDemoModal extends Component {
    constructor(props){
        super(props)
        this.state={
        }

    }

    

    render() {
         
        return (
                <Modal className={[styles[''],'book-demo-modal'].join(' ')}
                        show={this.props.showModal}
                        dialogClassName="modal-90w"
                        aria-labelledby="example-custom-modal-styling-title"
                        size='xl'
                        centered 
                        onHide={this.props.handleHideModal}>
                        <Modal.Header closeButton/>
                        
                                <Modal.Body className={[styles[''],'book-demo-modal-body'].join(' ')}>
                                {/* <!--  Book-demo Section --> */}
                                    <section className={[styles['book-demo'],''].join(' ')} id="BookDemo">
                                        <div className={[styles[''],'container'].join(' ')}>
                                            <div className={[styles[''],'row'].join(' ')}>
                                                <div className={[styles['heading'],'col-md-12 col-lg-6 text-left'].join(' ')}>
                                                    <h2>Book a Demo</h2>
                                                    <h6>Schedule a call with us to know more about the technology.</h6>
                                                    <p><img src={imageSrc[39].src}/> 
                                                        <span>Get your Account setup </span>
                                                        <span>Our team will help you setup your account</span>
                                                    </p>
                                                    <p className={[styles['book-calendly'],''].join(' ')}>
                                                        <img src={imageSrc[40].src}/> 
                                                        <span>Explore Solutions just for you </span>
                                                        <span>Understand how our Al Tech can solve your use-cases</span>
                                                    </p>
                                                  </div> 
                                                <div className={[styles[''],'col-md-12 col-lg-6'].join(' ')}>
                                                    <div className={[styles['calendly'],'row'].join(' ')}> 
                                                    <InlineWidget className={[styles['calendly-inline-widget'],'p-0'].join(' ')} url="https://calendly.com/spyneai/spyne-car-ai-linkedin?hide_event_type_details=1&hide_gdpr_banner=1"  style={{"minwidth": "320px", "height":"650px"}} />
                                                    </div> 
                                                </div>  
                                            </div>
                                        </div>
                                    </section>
                                {/* <!--  //Book-demo Section --> */}
                                </Modal.Body>

                         
                </Modal>
        )
    }
}
